<div class="alert mb-0 d-flex align-items-center">
    <ng-container
        *ngTemplateOutlet="
            engagement;
            context: {
                icon: ICON_LINK,
                count: links,
                text: 'Links',
                tabIndex: 0,
            }
        "
    >
    </ng-container>
    <div class="divider-end divider--short"></div>
    <ng-container
        *ngTemplateOutlet="
            engagement;
            context: {
                icon: ICON_LIKE,
                count: likes,
                text: 'Likes',
                tabIndex: 1,
            }
        "
    >
    </ng-container>
</div>

<ng-template
    #engagement
    let-icon="icon"
    let-count="count"
    let-text="text"
    let-tabIndex="tabIndex"
>
    <button
        class="btn btn-sm btn-outline-primary engagements__item d-flex align-items-center justify-content-center flex-grow-1 bg-transparent border-0"
        [class.pointer]="hasInfoModal"
        [modalId]="hasInfoModal ? instanceId : null"
        [attr.data-cy]="'action-open-' + text"
        (click)="onGetLinksAndLikes(tabIndex)"
    >
        <wdx-icon
            class="me-1"
            [class.text-body]="!count"
            [scale]="1"
            [icon]="icon"
            [fixedWidth]="true"
        ></wdx-icon>
        <h5>
            {{ count || 0 }}
            @if (responsiveShowText) {
                <span>&nbsp;{{ text }}</span>
            }
        </h5>
    </button>
</ng-template>

@if (hasInfoModal) {
    <atom-modal-wrapper
        [modalId]="instanceId"
        [modalTemplate]="engagementsInfoModal"
    >
        <ng-template #engagementsInfoModal>
            <organism-modal
                data-cy="modal-engagements-info"
                [modalTitle]="infoModalTitle | truncateText: 50"
            >
                <molecule-tabs
                    class="d-block h-100 tabs-bg-muted"
                    [name]="TABS_ID"
                >
                    <atom-tab
                        label="Linked Records"
                        cySelector="tab-linked-record"
                        [icon]="ICON_LINK"
                        [content]="linkedRecordsTab"
                    ></atom-tab>
                    <atom-tab
                        label="Liked By"
                        cySelector="tab-liked"
                        [icon]="ICON_LIKE"
                        [content]="likedByTab"
                    ></atom-tab>
                </molecule-tabs>
                <ng-template #linkedRecordsTab>
                    <atom-async-data
                        [isLoading]="
                            linkedActivitiesIsLoading || linkedCasesIsLoading
                        "
                        [hasError]="
                            linkedActivitiesHasError || linkedCasesHasError
                        "
                    >
                        @if (
                            linkedActivities
                                | fn
                                    : casesAndActivitiesAsInfoCards
                                    : linkedCases;
                            as allLinked
                        ) {
                            <div class="h-100 overflow-auto">
                                @for (linked of allLinked; track $index) {
                                    <ng-container
                                        *ngTemplateOutlet="
                                            resultInfoCard;
                                            context: {
                                                data: linked,
                                            }
                                        "
                                    ></ng-container>
                                }
                            </div>
                        }
                    </atom-async-data>
                </ng-template>
                <ng-template #likedByTab>
                    <atom-async-data
                        [isLoading]="likedByIsLoading"
                        [hasError]="likedByHasError"
                    >
                        @if (likedBy | fn: likedByAsInfoCards; as allLiked) {
                            <div class="h-100 overflow-auto">
                                @for (liked of allLiked; track $index) {
                                    <ng-container
                                        *ngTemplateOutlet="
                                            resultInfoCard;
                                            context: {
                                                data: liked,
                                            }
                                        "
                                    ></ng-container>
                                }
                            </div>
                        }
                    </atom-async-data>
                </ng-template>
                <ng-template #resultInfoCard let-data="data">
                    <molecule-info-card
                        class="d-block p-3 border-light border-bottom"
                        [primaryInfo]="data.primaryInfo"
                        [routerLinkData]="data.routerLink"
                        [secondaryInfo]="data.secondaryInfo"
                        [avatars]="data.avatars"
                        [icon]="data.icon"
                    ></molecule-info-card>
                </ng-template>
            </organism-modal>
        </ng-template>
    </atom-modal-wrapper>
}
